module.exports = __webpack_public_path__ + "static/media/placeholder.db714334.png";